export enum ButtonKind {
    DEFAULT = "default",
    CONFIRM = "confirm",
    DELETE = "delete",
    ICON = "icon",
    KEY = "key",
    LINK = "link",
};

export enum ButtonType {
    BUTTON = "button",
    SUBMIT = "submit",
}
